import { makeStyles } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import NegativeFaceIcon from '../icons/NegativeFaceIcon'
import NeutralFaceIcon from '../icons/NeutralFaceIcon'
import PositiveFaceIcon from '../icons/PositiveFaceIcon'
import BaseWidget from './common/BaseWidget'
import EngagementWidget from './common/EngagementWidget/EngagementWidget'

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1
  }
}))

const PatientsSentiment = ({ score, isLoading }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const selectedScoreKey = score > 7 ? 'positive' : score > 4 ? 'neutral' : 'negative'

  const scoreOptions = [
    {
      key: 'negative',
      fillColor: '#FFEEEE',
      strokeColor: '#EB5757',
      icon: NegativeFaceIcon,
      label: t('pages.copilotControl.widgets.patientsSentiment.negativeLabel'),
      description: t('pages.copilotControl.widgets.patientsSentiment.negativeDescription')
    },
    {
      key: 'neutral',
      fillColor: '#FFF5E1',
      strokeColor: '#FFBD39',
      icon: NeutralFaceIcon,
      label: t('pages.copilotControl.widgets.patientsSentiment.neutralLabel'),
      description: t('pages.copilotControl.widgets.patientsSentiment.neutralDescription')
    },
    {
      key: 'positive',
      fillColor: '#E9FDF3',
      strokeColor: '#26C36F',
      icon: PositiveFaceIcon,
      label: t('pages.copilotControl.widgets.patientsSentiment.positiveLabel'),
      description: t('pages.copilotControl.widgets.patientsSentiment.positiveDescription')
    }
  ]

  return (
    <BaseWidget carousel={false} className={classes.root}>
      <EngagementWidget
        comingSoon={true}
        isLoading={isLoading}
        title={t('pages.copilotControl.widgets.patientsSentiment.title')}
        scoreOptions={scoreOptions}
        selectedScore={scoreOptions.find(o => o.key === selectedScoreKey)}
      />
    </BaseWidget>
  )
}

export default PatientsSentiment
